import React, { Component } from "react";
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { BASEURL } from "../Config"
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import { Link } from 'react-router-dom';
import { getChapterInfo } from '../modules/actions';
import { getBookInfo } from "../modules/reducers";
import { connect } from "react-redux";
import { withRouter, NavLink } from 'react-router-dom';
import { compose } from "redux";
import swal from "sweetalert";

class Chapters extends Component {
    constructor(props) {
        super(props);
        this.state = {
            offset: 0,
            slice: [],
            perPage: 10,
            currentPage: 0,
            editableRow: null,
            cname: "",
            id: "",
            chapters: [],
            // Rearrange mode keeps its own copy of the list so dragging can be
            // cancelled without touching what is saved.
            isRearranging: false,
            rearranged: [],
            dragIndex: null,
            savingOrder: false
        }
        this.handlePageClick = this
            .handlePageClick
            .bind(this);
    }

    getBid() {
        return this.props.history.location.state ? this.props.history.location.state.bid : this.props.book._id;
    }

    receivedData() {
        let bid = this.getBid();
        axios
            .get(`${BASEURL}/api/v1/chapters/fetchChapters/${bid}`)
            .then(res => {
                console.log('res.data', res.data);
                const data = [];
                for (let i = 0; i < res.data.length; i++) {
                    if (!res.data[i].isDeleted) {
                        data.push(res.data[i]);
                    }
                }
                console.log('data', data);
                const slice = data.slice(this.state.offset, this.state.offset + this.state.perPage)
                console.log('slice', slice);
                this.setState({
                    chapters: data,
                    pageCount: Math.ceil(data.length / this.state.perPage),
                    slice
                })
            });
    }
    handlePageClick = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage * this.state.perPage;

        this.setState({
            currentPage: selectedPage,
            offset: offset
        }, () => {
            this.receivedData()
        });

    };

    componentDidMount() {
        this.receivedData()
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,

        })
    }

    handleUpdateChapter() {
        console.log('cname id', this.state.cname, this.state.id)
        let data = {};
        data.id = this.state.id;
        data.cname = this.state.cname;

        console.log('update data', data)
        axios.put(`${BASEURL}/api/v1/chapters/update`, data)
            .then(res => {
                if (res.status === 200) {
                    console.log('res.data', res.data);
                    this.receivedData()
                }
            })
            .catch((err) => {
                console.log('Update chapter Error', err);
            })
    }

    // ---- Rearrange ---------------------------------------------------------
    // The whole book is shown while rearranging (pagination off), otherwise a
    // chapter could never be moved from page 2 to page 1.

    handleStartRearrange = () => {
        this.setState({
            isRearranging: true,
            rearranged: [...this.state.chapters],
            editableRow: null,
            dragIndex: null
        });
    }

    handleCancelRearrange = () => {
        this.setState({ isRearranging: false, rearranged: [], dragIndex: null });
    }

    moveChapter = (from, to) => {
        if (from === to || to < 0 || to >= this.state.rearranged.length) {
            return;
        }
        const rearranged = [...this.state.rearranged];
        const [moved] = rearranged.splice(from, 1);
        rearranged.splice(to, 0, moved);
        this.setState({ rearranged });
    }

    handleDrop = (index) => {
        if (this.state.dragIndex === null) {
            return;
        }
        this.moveChapter(this.state.dragIndex, index);
        this.setState({ dragIndex: null });
    }

    handleSaveOrder = () => {
        const chapterIds = this.state.rearranged.map((chapter) => chapter._id);
        this.setState({ savingOrder: true });
        axios.put(`${BASEURL}/api/v1/chapters/reorder`, { bid: this.getBid(), chapterIds })
            .then(res => {
                this.setState({
                    isRearranging: false,
                    savingOrder: false,
                    rearranged: [],
                    dragIndex: null
                }, () => {
                    this.receivedData();
                    swal('Success', 'Chapter order saved', 'success');
                });
            })
            .catch((err) => {
                console.log('Reorder chapters Error', err);
                const message = err.response && err.response.data && err.response.data.message
                    ? err.response.data.message
                    : 'Could not save the new order';
                this.setState({ savingOrder: false });
                swal('Error', message, 'error');
            });
    }

    renderRearrangeRows() {
        return this.state.rearranged.map((data, idx) => (
            <tr key={data._id}
                draggable
                onDragStart={() => this.setState({ dragIndex: idx })}
                onDragOver={(e) => e.preventDefault()}
                onDrop={() => this.handleDrop(idx)}
                onDragEnd={() => this.setState({ dragIndex: null })}
                className={this.state.dragIndex === idx ? "table-warning" : ""}
                style={{ cursor: 'move' }}>
                <td className="table-user">
                    <i className="mdi mdi-drag-vertical" /> <strong>{idx + 1}.</strong> {data.cname}
                </td>
                <td>
                    <button className="btn" title="Move up"
                        disabled={idx === 0}
                        onClick={() => this.moveChapter(idx, idx - 1)}>
                        <i className="mdi mdi-arrow-up-bold" /></button>
                    <button className="btn" title="Move down"
                        disabled={idx === this.state.rearranged.length - 1}
                        onClick={() => this.moveChapter(idx, idx + 1)}>
                        <i className="mdi mdi-arrow-down-bold" /></button>
                </td>
            </tr>
        ));
    }

    handleOnAddTopics = (cid) => {
        this.props.dispatch(getChapterInfo(cid));
        this.props.history.push({
            pathname: '/addTopics',
            state: { cid: cid }
        });
    }

    handleOnViewTopics = (cid) => {
        this.props.dispatch(getChapterInfo(cid));
        this.props.history.push({
            pathname: '/topics',
            state: { cid: cid }
        });
    }

    handleOnDeleteChapter(id) {
        swal({
            title: "Are you sure?",
            text: "All the questions and topics related to this chapter will be deleted!",
            icon: "warning",
            buttons: [
              'No',
              'Yes'
            ],
            dangerMode: true,
          }).then(function(isConfirm) {
            if (isConfirm) {
                let obj = {};
                obj.id = id;
                obj.isDeleted = true;
                console.log('obj');
                axios.post(`${BASEURL}/api/v1/chapters/updateDeleteStatus`, obj)
                .then(res => {
                    if(res.status === 200) {
                        swal('Success', 'Chapter Deleted Successfully', 'success')
                        .then(function() {
                            window.location = "chapters";
                        })
                    } else {
                        swal('Error', 'Error in deleting the chapter', 'error')
                        .then(function() {
                            window.location = "chapters";
                        })
                    }
                })
            }
          });
    }


    render() {
        return (

            <div id="wrapper">
                <Sidebar act="books" />
                {/* Content Wrapper */}
                <div className="content-page">
                    {/* Main Content */}
                    <div className="content">
                        <Topbar act="Chapters" breadcrumbItems={['Test Generator', { label: 'Books', path: '/books' }, 'View Chapters']} />
                        {/* container */}
                        {/* content */}
                        <div className="container-fluid main-container">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card main-card">
                                        <div className="card-body">
                                            <h4 className="page-title">Book name: {this.props.book.name}</h4>
                                            <Link className="btn btn-primary brn-sm mr-2"
                                                to={{
                                                    pathname: "/addChapters"
                                                }}
                                            > <i className="mdi mdi-plus-circle" /> Add Chapters</Link>
                                            <Link className="btn btn-warning brn-sm mr-2"
                                                to={{
                                                    pathname: "/studyMaterial"
                                                }}
                                            > Study Materials</Link>
                                            {this.state.isRearranging ?
                                                <>
                                                    <button className="btn btn-success brn-sm mr-2"
                                                        disabled={this.state.savingOrder}
                                                        onClick={this.handleSaveOrder}>
                                                        <i className="mdi mdi-content-save-outline" /> {this.state.savingOrder ? 'Saving...' : 'Save Order'}
                                                    </button>
                                                    <button className="btn btn-secondary brn-sm"
                                                        disabled={this.state.savingOrder}
                                                        onClick={this.handleCancelRearrange}>Cancel</button>
                                                </>
                                                :
                                                <button className="btn btn-info brn-sm"
                                                    disabled={this.state.chapters.length < 2}
                                                    onClick={this.handleStartRearrange}>
                                                    <i className="mdi mdi-sort" /> Rearrange
                                                </button>
                                            }
                                            {this.state.isRearranging ?
                                                <p className="text-muted mt-2 mb-0">
                                                    Drag a chapter to a new position, or use the arrows, then click Save Order.
                                                </p>
                                                : null}
                                            <table className="table table-centered mb-0 mt-2">
                                                <thead>
                                                    <tr>
                                                        <th>Name of the Chapter</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {(this.state.isRearranging ? this.state.rearranged : this.state.slice).length === 0 ?
                                                        <tr className="text-center"><td colSpan="2">No chapters added</td></tr> :
                                                        this.state.isRearranging ? this.renderRearrangeRows() :
                                                        <>
                                                            {this.state.slice.map((data, idx) => (
                                                                <tr>
                                                                    <td className="table-user">
                                                                        {this.state.editableRow === idx ?
                                                                            <input type="text" id="chaptername" className="form-control" onChange={(e) => this.handleChange(e)}
                                                                                name="cname" placeholder="Enter Chapter Name"
                                                                                defaultValue={data.cname} disabled={this.state.editableRow !== idx} />
                                                                            :
                                                                            <input type="text" id="chaptername" className="form-control" onChange={(e) => this.handleChange(e)}
                                                                                name="cname" placeholder="Enter Chapter Name"
                                                                                value={data.cname} disabled={this.state.editableRow !== idx} />
                                                                        }
                                                                    </td>
                                                                    <td >
                                                                        {this.state.editableRow === idx ?
                                                                            <button className="btn btn-primary brn-sm table_Action_btns" onClick={() => { this.handleUpdateChapter(); this.setState({ editableRow: null }); }}><i className="mdi mdi-content-save-outline" />save</button> :
                                                                            <button className="btn"
                                                                                onClick={() => { this.setState({ editableRow: idx, id: data._id, cname: data.cname }) }}>
                                                                                <i className="mdi mdi-pencil" /></button>}
                                                                        <button className="btn" onClick={() => this.handleOnDeleteChapter(data._id)}> <i className="mdi mdi-delete" /></button>
                                                                        <button className="btn btn-success brn-sm table_Action_btns"
                                                                            onClick={() => this.handleOnAddTopics(data._id)}
                                                                        > <i className="mdi mdi-plus-circle" /> Topics</button>
                                                                        <button className="btn btn-warning brn-sm"
                                                                            onClick={() => this.handleOnViewTopics(data._id)}
                                                                        > <i className="mdi mdi-eye-circle" /> Topics</button>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </>
                                                    }
                                                </tbody>
                                            </table>

                                            {this.state.isRearranging ? null :
                                                <div className="pagination-div">
                                                    <ReactPaginate
                                                        previousLabel={"Previous"}
                                                        nextLabel={"Next"}
                                                        breakLabel={"..."}
                                                        breakClassName={"break-me"}
                                                        pageCount={this.state.pageCount}
                                                        marginPagesDisplayed={2}
                                                        pageRangeDisplayed={5}
                                                        onPageChange={this.handlePageClick}
                                                        containerClassName={"pagination"}
                                                        subContainerClassName={"pages pagination"}
                                                        activeClassName={"active"} />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* End of Main Content */}
                        <Footer />
                    </div>
                    {/* End of Content Wrapper */}
                </div>

            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        book: getBookInfo(state)
    }
}

// const mapDispatchToProps = dispatch => ({
//     getChapter: (cid) => dispatch(getChapterInfo(cid)),
// });

export default compose(withRouter, connect(mapStateToProps))(Chapters);